<div class="chat-container" [class.minimized]="isMinimized">
  <!-- Chat Loading Overlay -->
  <div class="chat-loader" *ngIf="isChatLoading">
    <div class="loader-content">
      <div class="spinner"></div>
      <p>Initializing Builder...</p>
    </div>
  </div>

  <!-- Header -->
  <div class="chat-header" [style.display]="isChatLoading ? 'none' : 'flex'">
    <div class="header-content">
      <div class="logo">
        <i class="fas fa-robot"></i>
        <h1>Website Builder Agent</h1>
      </div>
      <div class="chat-controls">
        <button class="control-btn clear-data-btn" 
                (click)="clearDataAndRestart()" 
                title="Clear all data and start fresh">
          <i class="fas fa-trash-alt"></i>
        </button>
        <button class="control-btn" (click)="toggleMinimize()" title="Minimize Chat">
          <i class="fas fa-minus"></i>
        </button>
        <div class="status" style="display: none;">
          <span class="status-indicator"></span>
          <span>Online</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Chat Messages Area -->
  <div class="chat-messages" #chatMessages [style.display]="isChatLoading ? 'none' : 'block'">
    <div class="message bot-message" *ngFor="let message of messages; trackBy: trackMessage" 
         [class.bot-message]="message.isBot" 
         [class.user-message]="!message.isBot">
      <div class="message-avatar">
        <i [class]="message.isBot ? 'fas fa-robot' : 'fas fa-user'"></i>
      </div>
      <div class="message-content">
        <div class="message-bubble" [innerHTML]="message.content"></div>
        <div class="message-time">{{ formatTime(message.timestamp) }}</div>
      </div>
    </div>
    
    <!-- Typing Indicator -->
    <div class="message bot-message typing-indicator" *ngIf="isTyping">
      <div class="message-avatar">
        <i class="fas fa-robot"></i>
      </div>
      <div class="message-content">
        <div class="message-bubble typing-bubble">
          <div class="typing-dots">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <span class="typing-text" style="display: none;">Otto is thinking...</span>
        </div>
      </div>
    </div>
  </div>





  <!-- Progress Indicator (Only for Deployment) -->
  <div class="progress-indicator" *ngIf="isDeploymentPhase() && isDeploying">
    <div class="progress-content">
      <div class="progress-phase">
        <i class="fas fa-rocket fa-pulse"></i>
        <span>{{ getPhaseDescription() }}</span>
      </div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="getDeploymentProgress()"></div>
      </div>
    </div>
  </div>

  <!-- Input Area -->
  <div class="chat-input-container" *ngIf="((!allQuestionsCompleted() || aiControlEnabled) || (currentPhase === ChatPhase.DEPLOYMENT && !isDeploying)) && !isChatLoading && !isGeneratingAIContent">
    
    <!-- AI Generation Loading Animation -->
    <!-- <div class="input-wrapper" *ngIf="isGeneratingAIContent">
      <div class="ai-generation-loading">
        <div class="loading-animation">
          <div class="ai-icon">
            <i class="fas fa-robot fa-pulse"></i>
          </div>
          <div class="loading-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
        <span class="loading-text">Generating the content for your website...</span>
        <div class="loading-subtitle">This may take a few moments</div>
      </div>
    </div> -->
    
    <!-- Deployment Loading Animation (shows during deployment regardless of question type) -->
    <div class="input-wrapper" *ngIf="isDeploying">
      <div class="deployment-loading">
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
        <span class="loading-text">{{ getDeploymentStatus() }}</span>
      </div>
    </div>

    <!-- AI-Controlled Text Input -->
    <div class="input-wrapper" *ngIf="shouldShowAIInput()">
      <div class="input-area">
        <textarea 
               #chatInput
               [(ngModel)]="userInput"
               (keydown)="onKeyPress($event)"
               [placeholder]="getAIInputPlaceholder()" 
               class="chat-textarea"
               rows="4"
               autocomplete="off"></textarea>
        <button (click)="sendMessage()" class="send-button" [disabled]="!userInput.trim()">
          <i class="fas fa-paper-plane"></i>
        </button>
      </div>
      
      <!-- Step 2.3: AI Follow-up Hints -->
      <div class="follow-up-hints" *ngIf="showFollowUpHints && getAIFollowUpHints().length > 0">
        <div class="hints-header">
          <i class="fas fa-lightbulb"></i>
          <span>Suggestions:</span>
        </div>
        <div class="hints-container">
          <button class="hint-btn" 
                  *ngFor="let hint of getAIFollowUpHints()" 
                  (click)="selectFollowUpHint(hint)"
                  title="Click to use this suggestion">
            {{ hint }}
          </button>
        </div>
      </div>
    </div>

    <!-- Multiselect Input for Capabilities -->
    <div class="input-wrapper" *ngIf="isDataCollectionPhase() && isCurrentQuestionMultiselect() && !isCurrentQuestionColorSelection() && !isDeploying && !isGeneratingAIContent && !aiControlEnabled">
      <div class="capabilities-multiselect">
        <div class="multiselect-container">
          <div class="multiselect-options">
            <div class="capability-option" 
                 *ngFor="let capability of capabilitiesOptions"
                 [class.selected]="isCapabilitySelectedForQuestion(capability)"
                 (click)="toggleCapabilityForQuestion(capability)">
              <i class="fas fa-check check-icon"></i>
              <span>{{ capability }}</span>
            </div>
          </div>
        </div>
        <div class="selected-capabilities" *ngIf="getSelectedCapabilitiesForQuestion().length > 0">
          <strong>Selected ({{ getSelectedCapabilitiesForQuestion().length }}):</strong>
          <div class="selected-list">
            <span class="selected-capability" *ngFor="let cap of getSelectedCapabilitiesForQuestion()">
              {{ cap }}
              <i class="fas fa-times remove-icon" (click)="toggleCapabilityForQuestion(cap)"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="multiselect-actions">
        <button class="btn btn-primary" 
                [disabled]="getSelectedCapabilitiesForQuestion().length === 0" 
                (click)="submitCapabilities()">
          <i class="fas fa-check"></i> Continue
        </button>
      </div>
      <!-- Skip button for optional questions -->
      <div class="skip-action" *ngIf="isCurrentQuestionOptional()">
        <button class="skip-btn" (click)="skipCurrentQuestion()">
          <i class="fas fa-arrow-right"></i> Skip
        </button>
      </div>
    </div>

    <!-- File Upload Input -->
    <div class="input-wrapper" *ngIf="isDataCollectionPhase() && isCurrentQuestionFile() && !isCurrentQuestionColorSelection() && !isDeploying && !isGeneratingAIContent && !aiControlEnabled">
      <div class="file-upload-container">
        <div class="file-upload-area" 
             [class.file-selected]="selectedFile"
             [class.drag-over]="isDragOver"
             (click)="triggerFileInput()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onFileDrop($event)">
          
          <input type="file" 
                 #fileInput 
                 [accept]="getCurrentFileTypes()"
                 (change)="onFileSelected($event)"
                 style="display: none;">
          
          <div class="upload-content" *ngIf="!selectedFile">
            <i class="fas fa-cloud-upload-alt upload-icon"></i>
            <div class="upload-text">
              <strong>Click to upload</strong> or drag and drop
            </div>
            <div class="upload-hint">{{ getCurrentFileHint() }}</div>
          </div>
          
          <div class="file-preview" *ngIf="selectedFile">
            <div class="file-info">
              <i class="fas fa-image file-icon"></i>
              <div class="file-details">
                <div class="file-name">{{ selectedFile.name }}</div>
                <div class="file-size">{{ formatFileSize(selectedFile.size) }}</div>
              </div>
              <button class="remove-file-btn" (click)="removeFile($event)">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <img *ngIf="filePreviewUrl" [src]="filePreviewUrl" class="image-preview" alt="Logo preview">
          </div>
        </div>
        
        <div class="file-actions">
          <button class="upload-btn" 
                  [disabled]="!selectedFile" 
                  (click)="uploadFile()">
            <i class="fas fa-check"></i> Use This Logo
          </button>
        </div>
      </div>
      
      <!-- Skip button for optional file questions -->
      <div class="skip-action" *ngIf="isCurrentQuestionOptional()">
        <button class="skip-btn" (click)="skipCurrentQuestion()">
          <i class="fas fa-arrow-right"></i> Skip
        </button>
      </div>
    </div>

    <!-- Form Input -->
    <div class="form-input-container" *ngIf="isDataCollectionPhase() && isCurrentQuestionForm() && !isCurrentQuestionColorSelection() && !isDeploying && !isGeneratingAIContent && !aiControlEnabled">
      <form class="chat-form" (ngSubmit)="submitForm()" #chatForm="ngForm">
        <div class="form-fields">
          <div class="form-field" *ngFor="let field of getCurrentFormFields()">
            <label [for]="field.field" class="field-label">
              {{ field.label }}
              <span class="optional-indicator" *ngIf="field.optional">(Optional)</span>
            </label>
            
            <!-- Equipment Textarea -->
            <textarea *ngIf="isEquipmentField(field.field)"
              [id]="field.field"
              [name]="field.field"
              [(ngModel)]="formData[field.field]"
              [placeholder]="field.placeholder"
              class="form-textarea"
              rows="4"
              [required]="!field.optional"
              autocomplete="off"></textarea>
            
            <!-- Capabilities Multiselect -->
            <div *ngIf="isCapabilitiesField(field.field)" class="capabilities-multiselect">
              <div class="multiselect-container">
                <div class="multiselect-options">
                  <div class="capability-option" 
                       *ngFor="let capability of capabilitiesOptions"
                       [class.selected]="isCapabilitySelected(capability)"
                       (click)="toggleCapability(capability)">
                    <i class="fas fa-check check-icon"></i>
                    <span>{{ capability }}</span>
                  </div>
                </div>
              </div>
              <div class="selected-capabilities" *ngIf="getSelectedCapabilities().length > 0">
                <strong>Selected ({{ getSelectedCapabilities().length }}):</strong>
                <div class="selected-list">
                  <span class="selected-capability" *ngFor="let cap of getSelectedCapabilities()">
                    {{ cap }}
                    <i class="fas fa-times remove-icon" (click)="toggleCapability(cap)"></i>
                  </span>
                </div>
              </div>
              <!-- Hidden input to satisfy Angular form validation -->
              <input type="hidden" 
                     [name]="field.field"
                     [(ngModel)]="formData[field.field]"
                     [required]="!field.optional">
            </div>
            
            <!-- Regular Input -->
            <input *ngIf="!isCapabilitiesField(field.field) && !isEquipmentField(field.field)"
              [id]="field.field"
              [name]="field.field"
              [(ngModel)]="formData[field.field]"
              [placeholder]="field.placeholder"
              [type]="getInputType(field.field)"
              class="form-input"
              [required]="!field.optional"
              autocomplete="off">
              
            <div class="field-help" *ngIf="field.help">{{ field.help }}</div>
            <div class="field-error" *ngIf="chatForm.controls[field.field]?.invalid && (chatForm.controls[field.field]?.dirty || chatForm.controls[field.field]?.touched)">
              This field is required
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button type="submit" class="btn btn-primary" [disabled]="!isFormValid() || chatForm.invalid">
            <i class="fas fa-check"></i> Continue
          </button>
        </div>
      </form>
    </div>

  </div>

  <!-- AI Content Generation Overlay -->
  <div class="ai-generation-overlay" *ngIf="isGeneratingAIContent">
    <div class="ai-generation-modal">
      <div class="ai-generation-content">
        <div class="ai-generation-icon">
          <i class="fas fa-robot fa-pulse"></i>
        </div>
        <h3 class="ai-generation-title">Generating Your Website Content</h3>
        <p class="ai-generation-description">OTTO is creating personalized content for your website based on your business information.</p>
        
        <!-- Progress Bar -->
        <div class="ai-progress-container">
          <div class="ai-progress-bar">
            <div class="ai-progress-fill"></div>
          </div>
          <div class="ai-progress-text">This may take a few moments...</div>
        </div>
        
        <!-- Loading Animation -->
        <div class="ai-loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Minimized Chat Indicator -->
<div class="minimized-chat" *ngIf="isMinimized">
  <div class="minimized-content">
    <div class="minimized-avatar">
      <i class="fas fa-robot"></i>
    </div>
    <div class="minimized-info">
      <div class="minimized-title">Website Builder</div>
      <div class="minimized-status">
        <span *ngIf="currentPhase === ChatPhase.DATA_COLLECTION && !isDeploying">Ready to help</span>
        <span *ngIf="currentPhase === ChatPhase.AI_GENERATION">Generating content...</span>
        <span *ngIf="currentPhase === ChatPhase.DEPLOYMENT && isDeploying">Deploying website...</span>
        <span *ngIf="currentPhase === ChatPhase.DEPLOYMENT && !isDeploying">Ready to deploy</span>
        <span *ngIf="isTyping">Typing...</span>
      </div>
    </div>
    <button class="restore-btn" (click)="toggleMinimize()">
      <i class="fas fa-expand"></i>
    </button>
  </div>
</div>
